module.exports = __webpack_public_path__ + "static/img/case_detail_09_2.c5f7cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_09_2.png
// module id = Z0fs
// module chunks = 34